import moment from 'moment';

export class SearchBlock {
	CLASS = {
		PAGE_BLOCK: 'corp-body',

		SEARCH_BLOCK: 'corp-search-block',
		SEARCH_BUTTON: 'corp-search-block__filter__btn-search',
		SEARCH_INPUT: 'corp-search-block__filter__input',
		SEARCH_SELECT: 'corp-search-block__filter__select',
		SEARCH_DATE_RANGE: 'corp-search-block__filter__dateRange',
		SEARCH_FIRST_LETTER: 'corp-search-block__filter__first-letters__letter',
		SEARCH_CHECKBOX: 'corp-search-block__filter__chk',
		SEARCH_CHECKBOX_ITEM: 'corp-search-block__filter__chk__item',

		THEME_BLOCK: 'corp-news-list-filter',
		THEME_BTN_APPLY: 'filter-btn-apply',
		THEME_BTN_DROP: 'filter-btn-drop',
		THEME_BTN_THEME: 'corp-search-block__btn-theme',
		THEME_BTN_CANCEL: 'corp-news-list__search-filter-btn-cancel',
		THEME_BTN_MOBILE_CLOSE: 'corp-news-list-filter__bg-mobile-close',
		THEME_OPEN_MENU: 'open-right-menu',
		THEME_ITEM: 'corp-news-list-filter-item',
		THEME_CHK_CONTAINER: 'corp-chk-container',
		THEME_CHK_CONTAINER_MAIN: 'main',
	};
	DATE_PICKER = {
		CANCEL_BUTTON: 'corp-split-datepicker__cancel-btn',
		VALUE: 'corp-split-datepicker__value',
		INPUT: 'corp-split-datepicker',
		FROM: 'corp-split-datepicker__dateFrom',
		TO: 'corp-split-datepicker__dateTo',
	};

	/** контейнер всей страницы */
	pageContainer: HTMLElement;

	/** контейнер в котором расположен поиск */
	searchBlock: HTMLElement;
	/** кнопка поиска */
	filterSearchBtn: HTMLLinkElement;
	/** текстовый поиск */
	filterInputs: HTMLInputElement[];
	/** поиск по первой букве */
	filterFirstLetter: HTMLElement[];
	/** поиск из списка */
	filterSelects: HTMLSelectElement[];
	/** поиск по датам */
	filterDateRanges: HTMLElement[];
	/** контейнер для чекбоксов*/
	filterCheckbox: HTMLElement;
	/** поиск по чекбоксам*/
	filterCheckboxItem: HTMLInputElement[];

	/** контейнер в котором расположен поиск по темам */
	themeBlock: HTMLElement;

	constructor() {
		this.pageContainer = document.querySelector(`.${this.CLASS.PAGE_BLOCK}`);
		if (!this.pageContainer) {
			return;
		}

		this.searchBlock = document.querySelector(`.${this.CLASS.SEARCH_BLOCK}`);
		if (this.searchBlock) {
			this.initSearchElements();
			this.initSearchFirstLetter();
			this.initSearchInputEnterHandler();
			this.initSearchButton();
			this.initSearchSelect();
			this.initSearchDatePickers();
			this.initSearchDatePickersFuture();
			this.initSearchDatePickersLast();
		}

		this.themeBlock = document.querySelector(`.${this.CLASS.THEME_BLOCK}`);
		if (this.themeBlock) {
			this.initMainChks();
			this.initThemeBtns();
		}
	}

	/**
	 * Инициализация чекбоксов, у которых есть дочерние
	 */
	initMainChks() {
		document
			.querySelectorAll<HTMLInputElement>(
				`.${this.CLASS.THEME_ITEM} .${this.CLASS.THEME_CHK_CONTAINER}.${this.CLASS.THEME_CHK_CONTAINER_MAIN}`
			)
			.forEach((theme) => {
				theme.querySelector('input').addEventListener('click', (e) => {
					theme.parentElement.parentElement.querySelectorAll<HTMLInputElement>('input').forEach((chk) => {
						chk.checked = (e.target as HTMLInputElement).checked;
					});
				});
			});
	}

	/**
	 * Инициализация кнопок для тем
	 */
	initThemeBtns() {
		const toggle = () => {
			this.themeBlock.classList.toggle(this.CLASS.THEME_OPEN_MENU);
		};
		document.querySelector(`.${this.CLASS.THEME_BTN_THEME}`).addEventListener('click', toggle.bind(this));
		document.querySelector(`.${this.CLASS.THEME_BTN_CANCEL}`).addEventListener('click', toggle.bind(this));
		document.querySelector(`.${this.CLASS.THEME_BTN_MOBILE_CLOSE}`).addEventListener('click', toggle.bind(this));

		const themeChks = document.querySelectorAll<HTMLInputElement>(`.${this.CLASS.THEME_ITEM} input`);

		document.querySelector(`.${this.CLASS.THEME_BTN_APPLY}`).addEventListener('click', (e) => {
			console.log('🚀 ~ file: searchBlock.ts ~ line 114 ~ SearchBlock ~ document.querySelector ~ e', e);
			const searchUrl = this.themeBlock.dataset['url'];
			const listParam = this.createSearchParams();

			let listHeading: string[] = [];
			themeChks.forEach((chk) => {
				if (chk.checked) {
					listHeading.push(chk.value);
				}
			});
			if (listHeading.length > 0) {
				listParam.push('idHeadingMain=' + listHeading.join(','));
			}

			const params = listParam.join('&');
			const newUrl = params ? `/${searchUrl}?${params}` : `/${searchUrl.replace('/search', '')}`;

			(e.target as HTMLLinkElement).href = newUrl;
		});

		document.querySelector(`.${this.CLASS.THEME_BTN_DROP}`).addEventListener('click', () => {
			themeChks.forEach((chk) => {
				chk.checked = false;
			});
		});
	}

	/**
	 * Инициализация элементов поиска
	 */
	initSearchElements() {
		this.filterSearchBtn = this.searchBlock.querySelector(`.${this.CLASS.SEARCH_BUTTON}`);
		this.filterInputs = Array.from<HTMLInputElement>(this.searchBlock.querySelectorAll(`.${this.CLASS.SEARCH_INPUT}`));
		this.filterFirstLetter = Array.from<HTMLElement>(
			this.searchBlock.querySelectorAll(`.${this.CLASS.SEARCH_FIRST_LETTER}`)
		);
		this.filterSelects = Array.from<HTMLSelectElement>(
			this.searchBlock.querySelectorAll(`.${this.CLASS.SEARCH_SELECT}`)
		);
		this.filterDateRanges = Array.from<HTMLElement>(
			this.searchBlock.querySelectorAll(`.${this.CLASS.SEARCH_DATE_RANGE}`)
		);
		this.filterCheckbox = this.searchBlock.querySelector(`.${this.CLASS.SEARCH_CHECKBOX}`);
		this.filterCheckboxItem = Array.from<HTMLInputElement>(
			this.searchBlock.querySelectorAll(`.${this.CLASS.SEARCH_CHECKBOX_ITEM}`)
		);
	}

	/**
	 * Добавляю обработчик нажатия "Enter"
	 */
	initSearchInputEnterHandler() {
		this.filterInputs.forEach((input) => {
			input.addEventListener('keyup', (event) => event.key === 'Enter' && this.filterSearchBtn.click());
		});
	}

	/**
	 * Инициализация календаря
	 */
	initSearchDatePickers() {
		const $ = (window as any)['$'];

		const datepickersBtns = Array.from<HTMLButtonElement>(
			this.searchBlock.querySelectorAll(`.${this.DATE_PICKER.CANCEL_BUTTON}`)
		);
		datepickersBtns.forEach((btn) => {
			btn.onclick = () => {
				$(`#${btn.parentElement.id} .${this.DATE_PICKER.VALUE}`).html('Выберите период');
				btn.parentElement.click();
			};
		});

		const inputDates = Array.from<HTMLElement>(this.searchBlock.querySelectorAll(`.${this.DATE_PICKER.INPUT}`));
		inputDates.forEach((datepicker) => {
			datepicker.addEventListener('click', (e) => {
				$('html, body').animate(
					{
						scrollTop: datepicker.offsetTop - datepicker.offsetHeight - 20,
					},
					500
				);
			});
		});
	}
	initSearchDatePickersFuture() {
		const $ = (window as any)['$'];

		$(`.${this.DATE_PICKER.INPUT}.isFuture`).each(function () {
			this.replaceMonthENtoRU = (date: string) => {
				return date
					.replace('Jan', 'янв.')
					.replace('Feb', 'фев.')
					.replace('Mar', 'мар.')
					.replace('Apr', 'апр.')
					.replace('May', 'май')
					.replace('Jun', 'июн.')
					.replace('Jul', 'июл.')
					.replace('Aug', 'авг.')
					.replace('Sep', 'сен.')
					.replace('Oct', 'окт.')
					.replace('Nov', 'ноя.')
					.replace('Dec', 'дек.');
			};
			this.DATE_PICKER = {
				CANCEL_BUTTON: 'corp-split-datepicker__cancel-btn',
				VALUE: 'corp-split-datepicker__value',
				INPUT: 'corp-split-datepicker',
				FROM: 'corp-split-datepicker__dateFrom',
				TO: 'corp-split-datepicker__dateTo',
			};
			const datepicker = this;

			$(`#${datepicker.id}`).daterangepicker(
				{
					autoApply: true,
					showDropdowns: true,
					ranges: {
						Сегодня: [moment(), moment()],
						Вчера: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
						'За последние 7 дней': [moment().subtract(6, 'days'), moment()],
						'В этом месяце': [moment().startOf('month'), moment().endOf('month')],
						'В прошлом месяце': [
							moment().subtract(1, 'month').startOf('month'),
							moment().subtract(1, 'month').endOf('month'),
						],
					},
					locale: {
						format: 'DD.MM.YYYY г.',
						separator: ' - ',
						applyLabel: 'Apply',
						cancelLabel: 'Cancel',
						fromLabel: 'From',
						toLabel: 'To',
						customRangeLabel: 'Произвольный период',
						weekLabel: 'W',
						daysOfWeek: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
						monthNames: [
							'Январь',
							'Февраль',
							'Март',
							'Апрель',
							'Май',
							'Июнь',
							'Июль',
							'Август',
							'Сентябрь',
							'Октябрь',
							'Ноябрь',
							'Декабрь',
						],
						firstDay: 1,
					},
					alwaysShowCalendars: true,
					buttonClasses: 'hide',
				},
				(start: any, end: any) => {
					let dateValue =
						this.replaceMonthENtoRU(start.format('DD MMM YYYY г.')) +
						' - ' +
						this.replaceMonthENtoRU(end.format('DD MMM YYYY г.'));
					document.querySelector(`#${datepicker.id} .${this.DATE_PICKER.VALUE}`).textContent = dateValue;
				}
			);

			$(`#${datepicker.id}`).on('cancel.daterangepicker', (ev: any, picker: any) => {
				$(datepicker).val('');
			});

			const spanDateFrom = document.querySelector(`#${datepicker.id} .${this.DATE_PICKER.FROM}`);
			const spanDateTo = document.querySelector(`#${datepicker.id} .${this.DATE_PICKER.TO}`);
			if (spanDateFrom && spanDateTo && spanDateFrom.innerHTML != '' && spanDateTo.innerHTML != '') {
				$(`#${datepicker.id}`).data('daterangepicker').setStartDate(spanDateFrom.innerHTML);
				$(`#${datepicker.id}`).data('daterangepicker').setEndDate(spanDateTo.innerHTML);
				$(`#${datepicker.id} .${this.DATE_PICKER.VALUE}`).html(
					this.replaceMonthENtoRU($(`#${datepicker.id}`).data('daterangepicker').startDate.format('DD MMM YYYY г.')) +
						' - ' +
						this.replaceMonthENtoRU($(`#${datepicker.id}`).data('daterangepicker').endDate.format('DD MMM YYYY г.'))
				);
			} else {
				$(`#${datepicker.id} .${this.DATE_PICKER.VALUE}`).html('Выберите период');
			}
		});
	}
	initSearchDatePickersLast() {
		const $ = (window as any)['$'];

		$(`.${this.DATE_PICKER.INPUT}.isLast`).each(function () {
			this.replaceMonthENtoRU = (date: string) => {
				return date
					.replace('Jan', 'янв.')
					.replace('Feb', 'фев.')
					.replace('Mar', 'мар.')
					.replace('Apr', 'апр.')
					.replace('May', 'май')
					.replace('Jun', 'июн.')
					.replace('Jul', 'июл.')
					.replace('Aug', 'авг.')
					.replace('Sep', 'сен.')
					.replace('Oct', 'окт.')
					.replace('Nov', 'ноя.')
					.replace('Dec', 'дек.');
			};
			this.DATE_PICKER = {
				CANCEL_BUTTON: 'corp-split-datepicker__cancel-btn',
				VALUE: 'corp-split-datepicker__value',
				INPUT: 'corp-split-datepicker',
				FROM: 'corp-split-datepicker__dateFrom',
				TO: 'corp-split-datepicker__dateTo',
			};
			const datepicker = this;

			$(`#${datepicker.id}`).daterangepicker(
				{
					autoApply: true,
					showDropdowns: true,
					ranges: {
						Сегодня: [moment(), moment()],
						'В этом месяце': [moment().startOf('month'), moment().endOf('month')],
						'В следующем месяце': [
							moment().subtract(-1, 'month').startOf('month'),
							moment().subtract(-1, 'month').endOf('month'),
						],
						'Прошедшие мероприятия': [moment('20190101', 'YYYYMMDD'), moment()],
					},
					locale: {
						format: 'DD.MM.YYYY г.',
						separator: ' - ',
						applyLabel: 'Apply',
						cancelLabel: 'Cancel',
						fromLabel: 'From',
						toLabel: 'To',
						customRangeLabel: 'Произвольный период',
						weekLabel: 'W',
						daysOfWeek: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
						monthNames: [
							'Январь',
							'Февраль',
							'Март',
							'Апрель',
							'Май',
							'Июнь',
							'Июль',
							'Август',
							'Сентябрь',
							'Октябрь',
							'Ноябрь',
							'Декабрь',
						],
						firstDay: 1,
					},
					alwaysShowCalendars: true,
					buttonClasses: 'hide',
				},
				(start: any, end: any) => {
					let dateValue =
						this.replaceMonthENtoRU(start.format('DD MMM YYYY г.')) +
						' - ' +
						this.replaceMonthENtoRU(end.format('DD MMM YYYY г.'));
					document.querySelector(`#${datepicker.id} .${this.DATE_PICKER.VALUE}`).textContent = dateValue;
				}
			);

			$(`#${datepicker.id}`).on('cancel.daterangepicker', (ev: any, picker: any) => {
				$(datepicker).val('');
			});

			const spanDateFrom: HTMLElement = document.querySelector(`#${datepicker.id} .${this.DATE_PICKER.FROM}`);
			const spanDateTo: HTMLElement = document.querySelector(`#${datepicker.id} .${this.DATE_PICKER.TO}`);

			if (spanDateFrom && spanDateTo && spanDateFrom.innerHTML != '' && spanDateTo.innerHTML != '') {
				$(`#${datepicker.id}`).data('daterangepicker').setStartDate(spanDateFrom.innerHTML);
				$(`#${datepicker.id}`).data('daterangepicker').setEndDate(spanDateTo.innerHTML);
				$(`#${datepicker.id} .${this.DATE_PICKER.VALUE}`).html(
					this.replaceMonthENtoRU($(`#${datepicker.id}`).data('daterangepicker').startDate.format('DD MMM YYYY г.')) +
						' - ' +
						this.replaceMonthENtoRU($(`#${datepicker.id}`).data('daterangepicker').endDate.format('DD MMM YYYY г.'))
				);
			} else {
				$(`#${datepicker.id} .${this.DATE_PICKER.VALUE}`).html('Выберите период');
			}
		});
	}

	/**
	 * Инициализация кнопки поиска
	 */
	initSearchButton() {
		/** url страницы поиска */
		const searchUrl = this.searchBlock.dataset['url'];

		this.filterSearchBtn.addEventListener('click', () => {
			const listParam = this.createSearchParams();
			const params = listParam.join('&');
			// const newUrl = `/${searchUrl}${params ? '/search?' + params : ''}`;
			const newUrl = params ? `/${searchUrl}?${params}` : `/${searchUrl.replace('/search', '')}`;
			this.filterSearchBtn.href = newUrl;
		});
	}

	/**
	 * Инициализация поиска по буквам
	 */
	initSearchFirstLetter() {
		this.filterFirstLetter.forEach((x) => {
			x.addEventListener('click', (e) => {
				e.preventDefault();
				this.filterFirstLetter.forEach((f) => {
					if (e.target != f) {
						f.classList.remove('active');
					}
				});
				(e.target as HTMLElement).classList.toggle('active');
				this.filterSearchBtn.click();
				return false;
			});
		});
	}

	/**
	 * Инициализация выборов из списка
	 */
	initSearchSelect() {
		const corpSelects = this.searchBlock.querySelectorAll('.corp-select');
		let selectTextSpan;
		corpSelects.forEach((selectDiv) => {
			const select = selectDiv.querySelector('select');

			const selectSelected = document.createElement('div');
			selectSelected.classList.add('select-selected');
			selectTextSpan = document.createElement('span');
			selectTextSpan.textContent = select.options[select.selectedIndex].textContent;
			selectSelected.appendChild(selectTextSpan);
			selectDiv.appendChild(selectSelected);

			const selectItems = document.createElement('div');
			selectItems.classList.add('select-items', 'select-hide');

			selectSelected.onclick = () => {
				selectItems.classList.toggle('select-hide');
				selectSelected.classList.toggle('select-arrow-active');
			};

			let selectMaxWidth = 0;
			select.querySelectorAll('option').forEach((item, index) => {
				const selectItem = document.createElement('div');
				selectTextSpan = document.createElement('span');
				selectTextSpan.textContent = item.textContent;
				selectItem.appendChild(selectTextSpan);

				selectItem.onclick = () => {
					selectItems.querySelectorAll('div').forEach((item1) => {
						item1.classList.remove('same-as-selected');
					});
					select.selectedIndex = index;
					selectItem.classList.add('same-as-selected');
					selectItems.classList.toggle('select-hide');
					selectSelected.querySelector('span').textContent = selectItem.textContent;
					selectSelected.classList.toggle('select-arrow-active');
				};
				selectItems.appendChild(selectItem);
			});
			selectDiv.appendChild(selectItems);
		});
	}

	/**
	 * Создание параметров для поиска
	 */
	createSearchParams(): string[] {
		const $ = (window as any)['$'];

		/** список параметров поиска */
		let listParam: string[] = [];

		/** добавляю параметр для поиска из буквенного поиска */
		if (this.filterFirstLetter.length > 0) {
			const activeLetter = this.filterFirstLetter.find((x) => x.classList.contains('active'));
			if (activeLetter) {
				listParam.push(`${activeLetter.parentElement.id}=${activeLetter.innerHTML}`);
			}
		}

		/** добавляю параметр для поиска из текстовых полей */
		this.filterInputs.forEach((input) => {
			if (input.value) {
				listParam.push(`${input.id}=${input.value}`);
			}
		});

		/** добавляю параметр для поиска из списков */
		this.filterSelects.forEach((select) => {
			if (select.value) {
				listParam.push(`${select.id}=${select.value}`);
			}
		});

		/** добавляю параметр для поиска из календаря */
		this.filterDateRanges.forEach((dateRange) => {
			let startDate = $(`#${dateRange.id}`).data('daterangepicker').startDate.format('YYYY-MM-DD');
			let endDate = $(`#${dateRange.id}`).data('daterangepicker').endDate.format('YYYY-MM-DD');
			let searchDateSpan = this.searchBlock.querySelector(`#${dateRange.id} .${this.DATE_PICKER.VALUE}`);
			if (startDate && searchDateSpan.innerHTML != 'Выберите период') {
				listParam.push(`${dateRange.id}DateFrom=${startDate}`);
			}
			if (endDate && searchDateSpan.innerHTML != 'Выберите период') {
				listParam.push(`${dateRange.id}DateTo=${endDate}`);
			}
		});

		/** добавляю параметр для поиска из списка чекбоксов */
		if (this.filterCheckbox && this.filterCheckboxItem.length > 0) {
			let chkArray: string[] = [];
			this.filterCheckboxItem.forEach((chk) => {
				if (chk.checked) {
					chkArray.push(chk.value);
				}
			});
			if (chkArray.length > 0) {
				listParam.push(`${this.filterCheckbox.id}=${chkArray.join(',')}`);
			}
		}
		return listParam;
	}
}
